<div class="transfer">
  <nz-transfer
    [nzDataSource]="list"
    [nzDisabled]="disabled"
    [nzTitles]="titles"
    [nzSelectedKeys]="selectedKeys"
    [nzShowSelectAll]="isSelectAllButtonVisible"
    [nzShowSearch]="isSearchable"
    [nzSearchPlaceholder]="placeholder"
    [nzNotFoundContent]="notFoundText"
    [nzTargetKeys]="key"
    (nzChange)="onValueChange($event)"
    (nzSelectChange)="onSelectChange($event)">
  </nz-transfer>
</div>
